import type { Dayjs } from 'dayjs';
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICalendarStateParams } from "../../../Orchestrator/Types/Interface/ActionParams/BookItAgainActionParams";
import { IDefaultActionResult } from '../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult';

export class BookItAgainModifiedDateAction extends BaseAction<IDefaultActionResult, ICalendarStateParams> {

    override async run(): Promise<IDefaultActionResult> {
        let result: IDefaultActionResult = {
            data: null,
            message: "",
            status: "fail"
        }
        try {
            const { dates, selectedRange, isRoundTripModalVisible } = this.params!
            if (dates === null) {
                // Clear the dates
                const newDates: [Dayjs | null, Dayjs | null] = [
                    selectedRange?.[0] || null,
                    null,
                ];
                updateRecoilState("calendarStateAtom", {
                    selectedDates: newDates,
                    isFilled: !!newDates[0],
                });
                updateRecoilState("selectedDateRangeStateAtom", newDates);
            } else {
                if (isRoundTripModalVisible) {
                    const outboundDate = dates[0]
                    if (outboundDate?.isBefore(new Date(), 'day')) {
                        result.message = "Selected outbound date for Book it gain can not be past"
                    } else {
                        const inboundDate = dates[1]
                        if (inboundDate?.isBefore(new Date(), 'day')) {
                            result.message = "Selected inbound date for Book it gain can not be past"
                        } else if (inboundDate?.isBefore(outboundDate)) {
                            result.message = `Selected inbound date(${inboundDate.format("DD-MM-YYYY")}) can not be less then outbound date(${outboundDate?.format("DD-MM-YYYY")})`
                        } else {
                            const newDates: [Dayjs | null, Dayjs | null] = [
                                selectedRange[0] == dates[1]
                                    ? dates[0]
                                    : dates[1]
                                        ? dates[1]
                                        : dates[0],
                                null,
                            ];
                            result.status = "success"
                            updateRecoilState("calendarStateAtom", {
                                selectedDates: newDates,
                                isFilled: !!newDates[0],
                            });
                            updateRecoilState("selectedDateRangeStateAtom", newDates);
                        }
                    }
                } else {
                    const outboundDat = dates[0]
                    if (outboundDat?.isBefore(new Date(), 'day')) {
                        result.message = "Select date for Book it gain can not be past"
                    } else {
                        // Handle normal case when isRoundTripModalVisible is false
                        updateRecoilState("calendarStateAtom", {
                            selectedDates: dates,
                            isFilled: !!dates && dates.length > 0 && !!dates[0],
                        });
                        updateRecoilState("selectedDateRangeStateAtom", dates);
                        result.status = "success"
                        if (dates[1]) {
                            updateRecoilState("inboundSelectedDateAtom", dates[1].toISOString());
                        }
                    }

                }
            }
        } catch (error) {
            result.message = "something went wrong"
        } finally {
            if (result.status === "success")
                updateRecoilState("dateSelectedFromCalendarAtom", true)
            else
                updateRecoilState("dateSelectedFromCalendarAtom", false)

            return result;
        }
    }
}

export const bookItAgainModifiedDateAction = new BookItAgainModifiedDateAction(); 